import axios from 'axios'

const $host = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
})

const $authHost = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
})

const $sdekHost = axios.create({
	baseURL: 'https://api.cdek.ru/v2/',
	withCredentials: false,
	headers: { 'Access-Control-Allow-Origin': '*' },
})

const $dadataHost = axios.create({
	baseURL: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/',
	mode: 'cors',
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		Authorization: `Token ${process.env.REACT_APP_DADATA_API_KEY}`,
	},
})

const authInterceptor = (config) => {
	config.headers.authorization = `Bearer ${localStorage.getItem('token')}`
	return config
}

$authHost.interceptors.request.use(authInterceptor)

export { $authHost, $dadataHost, $host, $sdekHost }
